import _ from 'lodash'
import constants from 'lib/constants'

const STAFF_ROLE = 'STAFF'
const VENDOR_ROLE = 'VENDOR'
const CLOZ_ADMIN_ROLE = 'CLOZ_ADMIN'
const PROVIDER_ROLE = 'PROVIDER'
const PATIENT_ROLE = 'PATIENT'

const imageNameRegEx = /(\d+)_(\d+).jpg/

export function isUserAdmin (user) {
  return _.get(user, 'is_admin') || _.get(user, 'admin')
}

export function isUserStaff (user) {
  return _.get(user, 'data.role') === STAFF_ROLE || _.get(user, 'is_admin') || _.get(user, 'admin')
}

export function isUserVendor (user) {
  return _.get(user, 'data.role') === VENDOR_ROLE
}

export function isUserOrgAdmin (user) {
  return _.get(user, 'data.role') === CLOZ_ADMIN_ROLE
}

export function isUserProvider (user) {
  return _.get(user, 'data.role') === PROVIDER_ROLE
}

export function isUserPatient (user) {
  return _.get(user, 'data.role') === PATIENT_ROLE
}

export function isDeviceActive (device) {
  return new Date() - new Date(device.last_active) < 5 * 60 * 1000
}

export function isDeviceLensShaded (device) {
  return device.data && _.size(device.data.lens_shading_history) > 0
}

export function isDeviceWorkingOnJob (job) {
  const deviceWorkStatuses = [constants.JOB_STATUSES.QUEUED, constants.JOB_STATUSES.IMAGING, constants.JOB_STATUSES.UPLOADING]
  return job && _.indexOf(deviceWorkStatuses, job.job_status) >= 0
}

export function isJobDone (job) {
  return job && (job.status === 1 || job.error_message)
}

export function truncateString (sourceString, maxLength) {
  if (sourceString.length > maxLength) {
    return `${sourceString.substring(0, maxLength - 3)}...`
  } else {
    return sourceString
  }
}

export function getLinacPositionFromImageName (imageName) {
  return imageName.match(imageNameRegEx)[1]
}

export function getZPosFromImageName (imageName) {
  return imageName.match(imageNameRegEx)[2]
}

export function getDateInputValue () {
  var local = new Date()
  local.setMinutes(local.getMinutes() - local.getTimezoneOffset())
  return local.toJSON().slice(0, 10)
}

// Pi <=3 serials are a 32-bit value zero-padded to 16 hex chars. Pi 4 / CM4
// carry a non-zero high word (e.g. 10000000xxxxxxxx).
export function isLegacyPiSerial (deviceString) {
  return /^0{8}[0-9a-f]{8}$/i.test(deviceString)
}

// Pi 1/2/3/Zero ship no MAC in hardware - the firmware synthesises both from
// the board serial, so we can reproduce them exactly. Pi 4 / CM4 burn
// independent addresses into OTP with no relation to the serial, so there is
// nothing to derive there and any result would be fiction: return null.
export function getMACAddress (deviceString, wifi = true) {
  if (!deviceString || !isLegacyPiSerial(deviceString)) return null

  // cast to hex int
  let macEnding = parseInt(deviceString.substring(deviceString.length - 6), 16)
  // xor last 6 bytes of serial number if WiFi
  if (wifi) {
    macEnding = macEnding ^ 0x555555
  }

  // prepend raspberry pi OUI. padStart matters: without it a leading zero
  // nibble shifts every octet left and renders a malformed address.
  const macAddr = 'B827EB' + macEnding.toString(16).padStart(6, '0')
  return macAddr.replace(/..\B/g, '$&:')
}

// The address the device actually reported always wins - it is read off the
// NIC and is correct on any hardware. Only fall back to deriving for boards
// where deriving is valid (i.e. devices that have never checked in).
export function resolveMACAddress (device, wifi = true) {
  const reported = wifi
    ? _.get(device, 'data.network.info.wifi_mac')
    : _.get(device, 'data.network.info.ether_mac')
  if (reported) return { mac: reported, derived: false }
  return { mac: getMACAddress(device.device_string, wifi), derived: true }
}



// WEBPACK FOOTER //
// ./src/lib/helpers.js